import { useEffect } from 'react';
import Highcharts from 'highcharts';
import Tree from 'highcharts/modules/treemap';
import exporting from 'highcharts/modules/exporting';
import data from 'highcharts/modules/data';
import Heatmap from 'highcharts/modules/heatmap';

Tree(Highcharts);
data(Highcharts);
Heatmap(Highcharts);
exporting(Highcharts);

const QAFlag = () => {
  const initialChart = () => {
    Highcharts.chart('QAFlag', {
      chart: {
        type: 'column',
      },

      title: {
        text: 'Flags',
      },

      xAxis: {
        type: 'category',
      },

      yAxis: {
        allowDecimals: true,
        min: 0,
        stackLabels: {
          enabled: true,
        },
        labels: {
          formatter: function () {
            return this.value;
          },
        },
        title: {
          text: null,
        },
      },

      credits: {
        enabled: false,
      },

      tooltip: { enabled: false },

      colors: ['#005cb1'],

      plotOptions: {
        column: {
          stacking: 'normal',
          groupPadding: 0,
          pointPadding: 0,
          shadow: false,
          borderWidth: 0,
        },
        series: {
          enableMouseTracking: false,
        },
      },

      series: [
        {
          name: 'Flags',
          data: [
            ['7 Oct', 15],
            ['8 Oct', 30],
            ['9 Oct', 12],
            ['10 Oct', 44],
            ['11 Oct', 76],
            ['12 Oct', 86],
            ['13 Oct', 99],
          ],
        },
      ],
    });
  };

  useEffect(() => {
    initialChart();
  }, []);

  return <div id="QAFlag" className="col-lg-3" />;
};

export default QAFlag;
